<template>
  <!-- 查看分类文档 -->
  <div class="viewDoc">
    <!-- 页头 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增帮助文档</el-button
        >
      </template>
    </page-bar>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="文章名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="zhaiyao"
        label="摘要"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="text"
            style="padding: 2px 3px"
            >未启用</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.status == 2"
            style="padding: 2px 3px"
            >已启用</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            v-if="scope.row.status == 1"
            @click="handleStatus(scope.row, 2)"
            >上架</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            v-if="scope.row.status == 2"
            @click="handleStatus(scope.row, 1)"
            >下架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "viewDoc",
  data() {
    return {
      id: "",
      /**表格数据 */
      // {
      //   id:"编号",
      //   name:"文章名称",
      //   level:"级别",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      Channel_Id: "",
    };
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.Channel_Id = prams.channel_id;
      this.getTableData();
    }
  },
  methods: {
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**获取数据 */
    getTableData() {
      let data = {
        channel_id: this.Channel_Id,
        category_id: this.id,
        entId: window.localStorage.getItem("entId"),
        status: "99",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Base/GetCategoryDocuments",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.tableData = res.dataList;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**添加/编辑文档 */
    handleAdd(row) {
      let prams = encodeURIComponent(
        JSON.stringify({ id: this.id, channel_id: this.Channel_Id })
      );
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({
            id: this.id,
            channel_id: this.Channel_Id,
            bjId: row.id,
          })
        );
      }
      this.$router.push({
        path: "EditKnow",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    // 删除文档
    handleDel(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            entId: window.localStorage.getItem("entId"),
            id: row.id,
          };
          this.$request({
            url: "Base/DeleteCategoryDocument",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 修改状态
    handleStatus(row, type) {
      let msg = "";
      if (type == 1) {
        msg = "确定禁用吗?";
      } else {
        msg = "确定启用吗?";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            entId: window.localStorage.getItem("entId"),
            status: type,
            id: row.id,
          };
          this.$request({
            url: "Base/AuditCategoryDocument",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.viewDoc {
  width: 100%;
  height: 100%;
}
</style>
